import { render } from "./SupplierAmount.vue?vue&type=template&id=7412231a"
import script from "./SupplierAmount.vue?vue&type=script&lang=js"
export * from "./SupplierAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__